import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=24008d0e&scoped=true&"
import script from "./LandingPage.vue?vue&type=script&lang=js&"
export * from "./LandingPage.vue?vue&type=script&lang=js&"
import style0 from "../../client/styles.css?vue&type=style&index=0&id=24008d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24008d0e",
  null
  
)

export default component.exports